import React, { Component } from 'react';
import styles from './index.css';
import fonts from '../../../../iconfonts.css';
import {observer} from 'mobx-react';
import {cropPlan, date, shipment} from '../../../stores/index';
import cultureSettings from "../../../stores/cultureSettings";


@observer
export default class Plan extends Component {
    cultures=[
        'wheat','rape','soy','sunflower','corn'
    ];
  render() {
    return (
      <div className={styles.planTab}>
        <div className={styles.inputTab}>
          <h3>Приймання</h3>
          <div className={styles.planTable}>
            <div className={styles.planRow}>
              <div className={styles.planCulture}>Культура</div>
              <div className={styles.planDay}>День</div>
              <div className={styles.planWeek}>Тиждень</div>
              <div className={styles.planMonth}>Місяць</div>
              <div className={styles.planSeason}>Сезон (Залишилось / Заплановано)</div>
            </div>
              {this.cultures.map((item,i)=>
                  <PlanRow culture={item} key={i}
                           day={Math.round(cropPlan.dayPlan[item])}
                           week={Math.round(cropPlan.weekPlan[item])}
                           month={Math.round(cropPlan.monthPlan[item])}
                           remainder={Math.floor(cropPlan.currentWeight[item])}
                           total={Math.floor(cropPlan.totalWeight[item])}
                  />
              )}
          </div>
        </div>
        <div className={styles.outputTab}>
          <h3>Вигрузка</h3>
          <div className={styles.planTable}>
            <div className={styles.planRow}>
              <div className={styles.planCulture}>Культура</div>
              <div className={styles.planDay}>День</div>
              <div className={styles.planWeek}>Тиждень</div>
              <div className={styles.planMonth}>Місяць</div>
              <div className={styles.planSeason}>Сезон (Залишилось)</div>
            </div>
              {this.cultures.map((item,i)=> {
                  let transport = shipment.outputTransport.filter((transport)=>(transport.culture===item));
                    let day = transport.reduce((prev, current)=>{
                        if(current.endDate.getFullYear() === date.day.getFullYear() &&
                            current.endDate.getMonth() === date.day.getMonth() &&
                            current.endDate.getDate() === date.day.getDate()){
                            return prev + current.quantity*(current.type === 'truck' ? 20 : 60)*cultureSettings[item].volume}
                        return prev;
                    },0);
                    const dateWeek = new Date(date.day.getFullYear(), date.day.getMonth(),date.day.getDate()+7,0,0,0)
                    let week = transport.reduce((prev, current)=>{
                        if(current.endDate <= dateWeek){
                            return prev + current.quantity*(current.type === 'truck' ? 20 : 60)*cultureSettings[item].volume
                        }
                        return prev;
                    },0);
                    const dateMonth = new Date(date.day.getFullYear(), date.day.getMonth()+1,date.day.getDate(),0,0,0);
                    let month = transport.reduce((prev, current)=>{
                      if(current.endDate <= dateMonth){
                          return prev + current.quantity*(current.type === 'truck' ? 20 : 60)*cultureSettings[item].volume
                      }
                      return prev;
                  },0);
                    let total = transport.reduce((prev, current)=>{
                            return prev + current.quantity*(current.type === 'truck' ? 20 : 60)*cultureSettings[item].volume
                    },0);
                     return <PlanRow culture={item} key={i}
                               day={Math.round(day)}
                               week={Math.round(week)}
                               month={Math.round(month)}
                               remainder={''}
                               total={Math.round(total)}
                      />
                  }
              )}
          </div>
        </div>
      </div>
    );
  }
}

@observer
class PlanRow extends Component {
    static defaultProps={day:0, week:0, month:0, remainder:0 ,total:0 }
    render() {
        return (
            <div className={styles.planRow}>
                <div className={styles.planCulture}>
                    <div className={styles.cultureCircle + ' ' + styles[this.props.culture]}><i
                        className={fonts[this.props.culture]}/></div>
                </div>
                <div className={styles.planDay}>{this.props.day} т.</div>
                <div className={styles.planWeek}>{this.props.week} т.</div>
                <div className={styles.planMonth}>{this.props.month} т.</div>
                {this.props.remainder !== '' ? (<div className={styles.planSeasonLeft}><strong>{this.props.remainder}
                    т.</strong>&nbsp;з&nbsp;</div>) : <div className={styles.planSeasonLeft}>{this.props.total} т.</div>}
                <div className={styles.planSeasonPlanned}>{this.props.remainder !== '' ? `${this.props.total} т.` : ''}</div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/Plan/index.js